export default {"src":"//jsak.mmtcdn.com/tripmoney/apps/landing-pages/_next/static/media/orderSuccess.e99c5624.svg","height":24,"width":24};